import React, { useEffect, useState } from 'react';
import { BellRing } from 'lucide-react';
import { toast } from 'sonner';
import API_URL from '@/config/api';
import { Card } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';

export function LeadNotificationPrefsCard() {
  const [prefs, setPrefs] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/me/notification-prefs`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : null)).then(setPrefs).catch(() => {});
  }, []);

  const save = async (patch) => {
    const next = { ...prefs, ...patch };
    setPrefs(next);
    const res = await fetch(`${API_URL}/api/me/notification-prefs`, {
      method: 'PUT', credentials: 'include', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ lead_email: next.lead_email, lead_sms: next.lead_sms }),
    });
    if (res.ok) toast.success('Notification preferences saved');
    else toast.error('Could not save preferences');
  };

  if (!prefs) return null;

  return (
    <Card className="p-6" data-testid="lead-notify-prefs-card">
      <div className="flex items-center gap-2 mb-1">
        <BellRing className="w-5 h-5 text-[#006400]" />
        <h2 className="text-lg font-semibold text-gray-900">Lead notifications</h2>
      </div>
      <p className="text-sm text-gray-500 mb-4">How we let you know the moment a new lead lands in your Lead CRM. You'll always get an in-app alert.</p>
      <div className="divide-y divide-gray-100">
        <label className="flex items-center justify-between gap-4 py-3 cursor-pointer">
          <div>
            <div className="text-sm font-medium text-gray-900">Email me</div>
            <div className="text-xs text-gray-500">{prefs.email || 'No email on file'}</div>
          </div>
          <Switch checked={prefs.lead_email} onCheckedChange={(v) => save({ lead_email: v })} data-testid="pref-lead-email" />
        </label>
        <label className="flex items-center justify-between gap-4 py-3 cursor-pointer">
          <div>
            <div className="text-sm font-medium text-gray-900">Text me (SMS)</div>
            <div className="text-xs text-gray-500">{prefs.phone ? `To ${prefs.phone}` : 'Add a mobile number in Company Information above to receive texts'}</div>
          </div>
          <Switch checked={prefs.lead_sms} onCheckedChange={(v) => save({ lead_sms: v })} data-testid="pref-lead-sms" />
        </label>
      </div>
    </Card>
  );
}
